module.exports = __webpack_public_path__ + "img/3000x1500.1592adc8.jpg";